import React from "react";
import { TableHeader } from "../../../../commons";
import { GSTR_THREEB_INVOICE_HEADER } from "../../../../../constant/tableHeadersConstants/gst/gstr3bConstant";
import GstrThreeBInvoiceTableData from "./GstrThreeBInvoiceTableData";

type AppProps = {
  gstrThreeBInvoiceData: any;
};
const GstrThreeBInvoiceTable = ({ gstrThreeBInvoiceData }: AppProps) => {
  const renderHead = () => {
    return (
      <tr className="p-1">
        <td colSpan={8} style={{ border: "none", backgroundColor: "#eef1f4" }}>
          <div>
            <div style={{ fontSize: "20px", fontWeight: "600" }}>
              {" "}
              {!gstrThreeBInvoiceData?.length
                ? "No Data Found"
                : "Source for invoicing advance"}
            </div>
            {gstrThreeBInvoiceData?.length > 0 && (
              <div
                className="mt-1"
                style={{ fontSize: "12px", color: "#6e7491" }}
              >
                Total {gstrThreeBInvoiceData?.length} records found
              </div>
            )}
          </div>
        </td>
      </tr>
    );
  };
  return (
    <tr style={{ backgroundColor: "#eef1f4" }}>
      <td colSpan={8}>
        <table width="100%" className="gstr-invoice-data">
          <thead>
            {renderHead()}
            {gstrThreeBInvoiceData?.length > 0 && (
              <TableHeader tableHeader={GSTR_THREEB_INVOICE_HEADER} />
            )}
          </thead>

          <tbody>
            <GstrThreeBInvoiceTableData
              tableHeader={GSTR_THREEB_INVOICE_HEADER}
              gstrOneInvoiceData={gstrThreeBInvoiceData}
            />
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default GstrThreeBInvoiceTable;
